<template>
  <div id="app" :class="[{'loading': isLoading, 'is-intro': !skipIntro}, currentPage, ]">
    <Arrow :isIntro="!skipIntro" />
    <div id="app-inner">
      <router-link
        data-hover="link"
        :class="{'disappear' : !skipIntro}"
        tag="div"
        class="logo"
        :to="{name:'home', params: {locale: $i18n.locale}}"
      >
        <Icon icon="dinamo-logo" />
      </router-link>
      <div
        :class="{'menu-open' : isMenuOpen}"
        class="menu-opener-wrapper"
        data-hover="link"
        @click="changeMenuStatus"
      >
        <div class="menu-opener">
          <Icon icon="hamburger" />
          <Icon icon="hamburger-close" />
        </div>
      </div>
      <transition
        appear
        name="fade"
        mode="out-in"
        @appear="$store.commit('loadingCursor', true)"
        @leave="$store.commit('loadingCursor', true)"
      >
        <router-view :key="$route.fullPath" class="router-view" />
      </transition>
      <Nav :isMenuOpen="isMenuOpen" />
    </div>
  </div>
</template>

<script>
import Nav from "@components/global/Nav";
import { mapGetters } from "vuex";
export default {
  components: {
    Nav
  },
  data() {
    return {
      openingMenu: false
    };
  },
  mounted() {
    if (this.skipIntro === null) {
      this.$store.commit(
        "skipIntro",
        sessionStorage.getItem("skipIntro") || false
      );
    }
    this.manageIntro();
    window.addEventListener("load", this.checkMobile);
    window.addEventListener("resize", this.checkMobile);
  },
  destroyed() {
    window.removeEventListener("load", this.checkMobile);
    window.removeEventListener("resize", this.checkMobile);
  },
  computed: {
    ...mapGetters({
      skipIntro: "skipIntro",
      isMenuOpen: "isMenuOpen",
      isLoading: "isLoading",
      isMobile: "getIsMobile",
      showNav: "getShowNav"
    }),
    currentPage() {
      return this.$route.name;
    }
  },
  watch: {
    $route(to, from) {
      this.$store.commit("changeMenuStatus", false);
      this.manageIntro();
    }
  },
  methods: {
    checkMobile($event) {
      if ($event.type === "load") {
        if (window.outerWidth >= 640) {
          this.$store.commit("setMobile", false);
        } else if (window.outerWidth < 640) {
          this.$store.commit("setMobile", true);
        }
        return;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (window.outerWidth >= 640 && this.isMobile) {
          this.$store.commit("setMobile", false);
        } else if (window.outerWidth < 640 && !this.isMobile) {
          this.$store.commit("setMobile", true);
        }
      }, 100);
    },
    changeMenuStatus() {
      if (this.openingMenu === false) {
        this.openingMenu = true;
        this.$store.commit(
          "changeMenuStatus",
          !this.$store.state.nav.isMenuOpen
        );
        setTimeout(() => {
          this.openingMenu = false;
        }, 800);
      }
    },
    manageIntro() {
      if (this.$route.name !== "home") {
        this.$store.commit("setShownav", true);
        if (!this.skipIntro) {
          this.$store.commit("skipIntro", true);
        }
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";

.fade-enter-active,
.fade-leave-active {
  -webkit-transition: opacity 0.5s ease-in-out, blur 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out, blur 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out, blur 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out, blur 0.5s ease-in-out;
  pointer-events: none !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  // filter: blur(3px);
}

.fade-enter-to,
.fade-leave {
  opacity: 1;
  // filter: blur(0px);
}

.fade-enter-active {
  -webkit-transition-delay: 0.5s;
  -moz-transition-delay: 0.5s;
  -o-transition-delay: 0.5s;
  transition-delay: 0.5s;
}

#app-inner {
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

#app {
  // &.home {
  //   overflow: hidden;
  // }
  // &:not(.is-intro) {
  //   @include breakpoint(large up) {
  //     padding: 64px;
  //   }
  // }
}
.logo {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  cursor: pointer;
  //background: $white;
  width: 64px;
  height: 64px;
  @include transition-duration(1.2s);
  &.disappear {
    @include transform(translateY(-100%));
  }
}
.menu-opener-wrapper {
  cursor: pointer;
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 64px;
  @include transition-duration(1.2s);
  z-index: 100;

  @include breakpoint(medium down) {
    height: 64px;
  }
  .menu-opener {
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
    position: absolute;
    width: 64px;
    height: 64px;
    @include transition-duration(1.2s);
    overflow: hidden;
    @include breakpoint(medium down) {
      bottom: unset;
    }
    & /deep/ svg {
      @include transition-duration(0.8s);
      &:last-of-type {
        position: absolute;
        top: 0;
        left: 0;
        @include transform(translateX(100%));
      }
      g rect {
        @include breakpoint(medium down) {
          fill: #c9c9c9;
        }
      }
    }
  }
  &.disappear {
    @include transform(translateX(100%));
  }
  &:not(.menu-open) {
    .menu-opener /deep/ svg:first-of-type rect:last-of-type {
      @include transition-duration(0.3s);
    }
    &:hover {
      .menu-opener /deep/ svg:first-of-type rect:last-of-type {
        @include transform(translate(1872px, 44px) scaleX(2));
      }
    }
  }
  &.menu-open {
    .menu-opener {
      & /deep/ svg {
        &:first-of-type {
          @include transform(translateX(-100%));
        }
        &:last-of-type {
          @include transform(translateX(0));
        }
      }
    }
    .menu-opener /deep/ svg:last-of-type rect {
      @include transition-duration;
    }
    &:hover {
      .menu-opener /deep/ svg:last-of-type {
        rect:first-of-type {
          x: 18.1507568px;
          width: 29.6984844px;
        }
        rect:last-of-type {
          x: 18.1507568px;
          width: 29.6984844px;
        }
      }
    }
  }
}
</style>
